export default __webpack_public_path__ + "locales/sl/UploadPanel.json?hash=b126bc03a1fbff3be57ac50d372b7766";